import React from 'react';
import extractArrayData from '../../../utils/extractArrayData';
import { Contentful } from '../../../types';
import HorizontalCardContent from '../../HorizontalCardContent/HorizontalCardContent';
import OutlinedCardItem from '../../UI/OutlinedCardItem/OutlinedCardItem';

interface Props {
  phaseClickHandler: (...args: any[]) => any;
  phobioData: {
    combinatorSectionItems: Array<any>;
  };
  phonePage?: boolean;
  reservationBlade?: boolean;
  mainContentId?: string;
}

const Phase0 = ({
  phaseClickHandler,
  phobioData,
  phonePage = false,
  reservationBlade = false,
  mainContentId = "5bzGjpUm80YCwiCyIG3ukU",
}: Props) => {
  const mainContent = extractArrayData(
    phobioData?.combinatorSectionItems,
    Contentful.ContentfulId,
    phonePage ? 'Laol9uvAyhPBA3xn7HChg' : mainContentId,
  );
  const isSmall = phonePage || reservationBlade;
  return (
    <OutlinedCardItem isSmall={isSmall} disableBorder>
      <HorizontalCardContent
        buttonText={mainContent?.cardCta?.ctaLabel?.ctaLabel}
        buttonColour={mainContent?.cardCta?.ctaColor}
        iconTestId="phobio-phase0-points-icon"
        titleTestId="phobio-phase0-main-title"
        buttonTestId="phobio-phase0-quote-button"
        isSmall={isSmall}
        onClick={() => phaseClickHandler('1')}
        buttonId="startButton"
        route={mainContent?.cardCta?.ctaTarget}
        url={mainContent?.cardCta?.ctaUrl}
        image={mainContent?.cardIcon}
        title={mainContent?.cardHeading}
      />
    </OutlinedCardItem>
  );
};

export default Phase0;
